import axios from '../axios';

// first parameter - event category
// second parameter - event action
// third parameter - event description
// fourth parameter - depot name (optional)
export default async function addGAEvent(...arg) {
  const [event, action, description, depot] = [...arg];
  await axios.post('/user-activity-audit', { data: {
    event, action, description, depot,
  } });
}
